import { OPEnum } from "~/types/op";

export const homePath = "/";

// external
export const curiosaPath = "https://curiosa.io";
export const playNetworkPath = "https://play.sorcerytcg.com";
export const storePath = (id: string) => `https://play.sorcerytcg.com/stores/${id}`;
export const shopPath = "https://shop.sorcerytcg.com";

// auth / setup
export const forbiddenPath = "/403";
export const notFoundPath = "/404";
export const serverErrorPath = "/500";
export const authErrorPath = "/512";
export const verifyPath = "/verify";
export const loginPath = (redirect: string) => `/api/auth/login?redirect=${redirect}`;
export const registerPath = (redirect: string) =>
  `/api/auth/login?redirect=${redirect}&hint=signup`;
export const logoutPath = "/api/auth/logout";

// play
export const howToPlayPath = "/how-to-play";
export const formatsPath = "/formats";
export const constructedPath = "/constructed";
export const draftPath = "/draft";
export const sealedPath = "/sealed";
export const organizedPlayPath = "/organized-play";
export const cornerstonePath = `${organizedPlayPath}?tab=${OPEnum.CORNERSTONE}`;
export const crossroadsPath = `${organizedPlayPath}?tab=${OPEnum.CROSSROADS}`;
export const avatarPath = `${organizedPlayPath}?tab=${OPEnum.AVATAR}`;

export const registerStorePath = `${playNetworkPath}/organizer-application`;

// cards
export const alphaPath = "/alpha";
export const betaPath = "/beta";
export const arthurianPath = "/arthurian-legends";
export const dragonlordPath = "/dragonlord";
export const allCardsPath = `${curiosaPath}/cards`;

// explore
export const newsPath = "/news";
export const newsItemPath = (slug: string) => `${newsPath}/${slug}`;
export const artPath = "/art";
export const artistPath = (slug: string) => `${artPath}/${slug}`;
export const locatorPath = "/locator";
export const decksPath = `${curiosaPath}/decks`;
export const eventsPath = `${playNetworkPath}/events`;

// retailers
// export const productsPath = '/products';
// export const distributorsPath = '/distributors';
export const becomeARetailerPath = "/become-a-retailer";

// account
export const accountPath = "/account";
export const authenticatePath = "/authenticate";
export const dustStorePath = `${playNetworkPath}/store`;

// company
export const aboutPath = "/about";
export const contactPath = "/contact";
export const careersPath = "/careers";
export const privacyPath = "/privacy";
export const termsPath = "/terms";

export const jobPath = (slug: string) => `/careers/${slug}`;

// dunno
export const rulebookPath =
  "https://drive.google.com/file/d/1sgQo0xf0N2teIR0zlyl91g9j6LVncZnr/view";
export const discordGroupPath = "https://discord.gg/qvYVGFAS5n";
export const fbGroupPath = "https://www.facebook.com/groups/sorceryofficial";
export const collectionGuidePath = `${curiosaPath}/collection/guide`;

// apis
export const authenticateApiPath = "/api/serial/authenticate";
